import { AfterViewInit, ChangeDetectorRef, Component, Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ContactanosModel } from '../../models/contactanos.model';
import { Contactanoservice } from '../../services/contatanos.service';
import { InmuebleResponse } from '../../models/InmueblesResponse';
import { Estado } from '../../models/InmuebleSearch.model.response';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { SearchService } from '../../services/search.service';
import { MatDialog } from '@angular/material/dialog';
import { OpExitosaModalComponent } from '../op-exitosa-modal/op-exitosa-modal.component';
@Component({
  selector: 'app-contactanos',
  templateUrl: './contactanos.component.html',
  styleUrls: ['./contactanos.component.css'],
  standalone: false
})
export class ContactanosComponent implements OnInit {
  payLoadOportunidad: ContactanosModel = new ContactanosModel();
  OK: string = 'OK';
  formContactanos!: UntypedFormGroup;
  estados: Estado[] = [];
  listo: boolean = false;
  public enviado = false;
  constructor(
    private contactanoservice: Contactanoservice,
    private searchService: SearchService,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef
  ) { }
  ngOnInit() {
    this.inicializarFormulario();
    this.obtenerEstados();
  }
 private inicializarFormulario() {
   this.formContactanos = new UntypedFormGroup({
     informacion: new UntypedFormControl('', Validators.required),
     estado: new UntypedFormControl('', Validators.required),
     contacto: new UntypedFormControl('', Validators.required),
     nombre: new UntypedFormControl('', [Validators.required, this.nombreValido()]),
     apellidoPaterno: new UntypedFormControl('', [Validators.required, this.nombreValido()]),
     apellidoMaterno: new UntypedFormControl('', this.nombreValido()),
     correo: new UntypedFormControl('', [Validators.required, Validators.email]),
     telcel: new UntypedFormControl('', [Validators.required, this.telefonoValido()]),
     telfijo: new UntypedFormControl('', this.telefonoValido()),
     mensaje: new UntypedFormControl('', [Validators.maxLength(100)])
   });
 }

  private nombreValido() {
    return (control: UntypedFormControl): { [key: string]: any } | null => {
      const valor: string = (control.value || '').trim();

      if (!valor) {
        return null;
      }

      if (valor.length < 2 || valor.length > 50) {
        return { longitud: true };
      }

      if (valor.length === 2 && valor[0].toLowerCase() === valor[1].toLowerCase()) {
        return { repetidos: true };
      }

      return null;
    };
  }
 
  private telefonoValido() {
    return (control: UntypedFormControl): { [key: string]: any } | null => {
      const valor: string = control.value;
      if (!valor) {
        return null;
      }

      const diezDigitos = /^\d{10}$/;

      const repetidos5 = /(.)\1{5,}/;

      if (repetidos5.test(valor)) {
        return { repetidos5: true };
      }

      if (!diezDigitos.test(valor)) {
        return { telefonoInvalido: true };
      }

      return null;
    };
  }

  public obtenerEstados(): void {
    this.searchService.obtenerEstados()
      .subscribe({
        next: (response) => {
          this.estados = response.respuesta.estados;
          this.listo = true;
          this.cdRef.detectChanges(); // Forzar detección de cambios después de cargar estados
        },
        error: (error) => {
          console.error("Error al obtener estados:", error);
          this.listo = true;
        }
      });
  }

  guardarContactanos() {
    if (!this.formContactanos.valid) {
      Swal.fire({
        icon: "error",
        title: "Informacion Incompleta...",
        text: "Debe registrar todos los campos requeridos..!",
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#eb0029'
      });
      return;
    }
    // prevenir doble envío
    if (this.enviado) {
      return;
    }
    this.enviado = true;
    // llenado de info
    const f = this.formContactanos!;
    this.payLoadOportunidad = {
      contacto: f.get('contacto')!.value,
      correo: f.get('correo')!.value,
      estado: f.get('estado')!.value,
      informacion: f.get('informacion')!.value,
      mensaje: f.get('mensaje')!.value,
      nombre: f.get('nombre')!.value,
      apellido1: f.get('apellidoPaterno')!.value,
      apellido2: f.get('apellidoMaterno')!.value,
      telcel: f.get('telcel')!.value,
      telfijo: f.get('telfijo')!.value
    };
    this.contactanoservice.guardarNuevaOportunidad(this.payLoadOportunidad)
      .subscribe({
        next: (data: InmuebleResponse) => {
          if (data.mensaje === this.OK) {
            // Guardar valores actuales para referencia
            const estadoId = this.formContactanos.get('estado')!.value;
            const infoValue = this.formContactanos.get('informacion')!.value;

            // Reset con valores vacíos para todos los campos
            const resetValues = {
              informacion: '',
              estado: '',
              contacto: '',
              nombre: '',
              apellidoPaterno: '',
              apellidoMaterno: '',
              correo: '',
              telcel: '',
              telfijo: '',
              mensaje: ''
            };
            this.openModalExitoso();
            this.formContactanos.reset(resetValues);
            this.selectedEstadoText = '';
            this.selectedInformacionText = '';
            this.enviado = false;
          } else {
            this.enviado = false;
            console.log("Error: no OK");
          }
        },
        error: (error) => {
          this.enviado = false;
          console.error(error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Algo salió mal!",
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#eb0029'
          });
        }
      });
  }
  soloNumeros(event: KeyboardEvent): void {
    const key = event.key;
    if (!/^\d$/.test(key) && key !== 'Backspace' && key !== 'Tab' &&
      key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Delete') {
      event.preventDefault();
    }
  }

  soloLetras(event: KeyboardEvent): void {
    const key = event.key;

    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/;

    if (!regex.test(key) &&
        key !== 'Backspace' &&
        key !== 'Tab' &&
        key !== 'ArrowLeft' &&
        key !== 'ArrowRight' &&
        key !== 'Delete') {
      event.preventDefault();
    }
  }

  openModalExitoso(): void {
    const dialogRef = this.dialog.open(OpExitosaModalComponent, {
      panelClass: 'modal-exitoso',
      autoFocus: false,
      disableClose: true
    });

    document.body.classList.add('disable-scroll');

    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('disable-scroll');
    });
  }

  // Método para reiniciar completamente el formulario si es necesario
  reiniciarFormulario() {
    this.inicializarFormulario();
    this.cdRef.detectChanges();
  }

  openedSelect: string = '';
  selectedInformacionText: string = '';
  selectedEstadoText: string = '';
  informacionRotation: number = 0;
  estadoRotation: number = 0;

  toggleSelect(field: string) {
    const wasOpen = this.openedSelect === field;
    const previouslyOpened = this.openedSelect;

    if (wasOpen) {
      this.openedSelect = '';
      this.updateRotation(field);
    } else {
      if (previouslyOpened) this.updateRotation(previouslyOpened);
      this.openedSelect = field;
      this.updateRotation(field);
    }
  }

  updateRotation(field: string) {
    switch (field) {
      case 'informacion':
        this.informacionRotation -= 180;
        break;
      case 'estado':
        this.estadoRotation -= 180;
        break;
    }
  }

  selectInformacion(valor: string, texto: string) {
    this.selectedInformacionText = texto;
    this.formContactanos.get('informacion')?.setValue(valor);
    this.toggleSelect('informacion');
  }

  selectEstado(estado: Estado) {
    this.selectedEstadoText = estado.nombre;
    this.formContactanos.get('estado')?.setValue(estado.idEstado);
    this.toggleSelect('estado');
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const isInside = target.closest('.custom-select-wrapper');

    if (!isInside && this.openedSelect !== '') {
      const prev = this.openedSelect;
      this.openedSelect = '';
      this.updateRotation(prev);

      if (prev === 'informacion' && !this.selectedInformacionText) {
        this.formContactanos.get('informacion')?.setValue('');
      }
      if (prev === 'estado' && !this.selectedEstadoText) {
        this.formContactanos.get('estado')?.setValue('');
      }
    }
  }

  limpiarForm() {
    this.formContactanos.reset({
      informacion: '',
      estado: '',
      contacto: '',
      nombre: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      correo: '',
      telcel: '',
      telfijo: '',
      mensaje: ''
    });
    this.selectedEstadoText = '';
    this.selectedInformacionText = '';
    this.formContactanos.markAsPristine();
    this.formContactanos.markAsUntouched();
    this.formContactanos.updateValueAndValidity();
  }
  
  isReadonly = true;
  disableReadonly(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    input.removeAttribute('readonly');
    this.isReadonly = false;
  }
}